export default __webpack_public_path__ + "static/media/tool-icon-goal-large.ed3e186a.svg";